import { Component, Input } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Param } from 'src/app/widgets';

@Component({
  selector: 'app-sketchfab',
  templateUrl: './sketchfab.component.html',
  styleUrls: ['./sketchfab.component.scss']
})
export class SketchfabComponent {
  @Input() contentJSON: any;
  @Input() environmentJSON: any;

  constructor(
    public dataService: DataService
  ) { }

  ngOnInit(): void {
  }

  trackByFn(index, item) {
    return index;
  }
}
